// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ddf81fb6","913":"976323fa"}[chunkId] + ".chunk.js";
};